// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDeleteFile_container__EGGc8"};